import { computed } from 'vue';
import { useProductType } from '@composables/useProductType';
import { useProductData } from '@composables/useProductData';
import safeType from '@utils/safeType';
import useSelectedLatchkey from './useSelectedLatchkey';

/**
 * @param {Product} [product]
 * @returns {product is LatchKeyProduct}
 */
function isLatchKeyProduct(product) {
  if (!product) {
    return false;
  }

  const { isLatchKey } = useProductType();

  return isLatchKey;
}

/**
 *
 * @returns {{
 *  latchKeyGroups: import('vue').ComputedRef<string[]>,
 *  latchKeyProductIdsByGroup: import('vue').ComputedRef<Record<string,ProductId[]>>,
 *  selectedLatchkey: import('vue').WritableComputedRef<string>,
 * }}
 */
export default function useLatchkey() {
  const product = useProductData().value;

  if (isLatchKeyProduct(product)) {
    const latchKeyGroups = computed(() => safeType(product.detail.orderedMasterGroupList, []));
    const latchKeyProductIdsByGroup = computed(() => safeType(product.detail.memberDisplayGroupsMap, {}));
    const selectedLatchkey = useSelectedLatchkey(product.id);

    return {
      latchKeyGroups,
      latchKeyProductIdsByGroup,
      selectedLatchkey,
    };
  }

  return {
    latchKeyGroups: computed(() => []),
    latchKeyProductIdsByGroup: computed(() => ({})),
    selectedLatchkey: computed(() => ''),
  };
}
